import { AvatarV2, Container, Icon, Notifications } from "@jds/core";
import { useEffect, useRef, useState } from "react";
import FormErrorLabel from "../../FormErrorLabel/FormErrorLabel";
import {
  imgValidationCheck,
  validateFileSignature,
} from "../../../../util/helper";

const AvatarUpload = (props) => {
  const [fileBlob, setFileBlob] = useState();
  const imgFileRef = useRef(null);
  const {
    image,
    fileValue = () => {},
    accept,
    error,
    errorText,
    id,
    badgeActionIcon,
  } = props;
  useEffect(() => {
    setFileBlob(null);
  }, [props.clearFileBlob]);
  return (
    <>
      <input
        key={id}
        ref={imgFileRef}
        type="file"
        style={{ display: "none" }}
        onChange={(e) => {
          const file = e.target.files[0];
          if (file && imgValidationCheck(e)) {
            validateFileSignature(file, {
              jpeg: ["ffd8ffe0", "ffd8ffe1", "ffd8ffe2", "ffd8ffdb"], // JPEG signatures can vary
              png: ["89504e47"],
            })
              .then((isValid) => {
                if (isValid) {
                  setFileBlob(URL.createObjectURL(file));
                  fileValue(file);
                } else {
                  Notifications.toast.error({
                    id: "event-banner-input-img",
                    title:
                      "Please upload a valid image file (JPG, JPEG and PNG).",
                  });
                }
              })
              .catch((error) => {
                Notifications.toast.error({
                  id: "event-banner-input-img",
                  title:
                    "Please upload a valid image file (JPG, JPEG and PNG).",
                });
              });
          } else {
            Notifications.toast.error({
              id: "event-banner-input-img",
              title: "Please upload a valid image file (JPG, JPEG and PNG).",
            });
          }
        }}
        accept={accept}
        id={id}
      />
      <div style={{ textAlign: "center", position: "relative" }} key={id}>
        <AvatarV2
          size="xtra-xtra-large"
          kind="information"
          avatarKind={image || fileBlob ? "image" : "icon"}
          badgeBorder={false}
          informationBadgeIcon={!badgeActionIcon && "IcCamera"}
          informationBadgeColor="neutral"
          onClick={() => {
            imgFileRef.current.click();
          }}
          {...props}
          image={fileBlob ? fileBlob : image}
        />

        {error && <FormErrorLabel errorMsg={errorText} />}
        {badgeActionIcon && (
          <Container
            horizontalAlign="center"
            verticalAlign="center"
            style={{
              width: "34px",
              height: "34px",
              backgroundColor: "rgba(0,0,0,.7)",
              borderRadius: "50%",
              position: "absolute",
              right: 0,
              bottom: "8px",
            }}
          >
            <Icon
              ic={"IcCamera"}
              color="white"
              onClick={() => {
                imgFileRef.current.click();
              }}
              {...props?.iconProps}
            />
          </Container>
        )}
      </div>
    </>
  );
};

export default AvatarUpload;
